import React from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { verticalChildSpacing } from 'components/utils/spacing'
import { rem } from 'polished'
import styled, { keyframes } from 'styled-components'
import FacebookRoundIcon from 'components/Luxkit/Icons/custom/FacebookRoundIcon'
import Spacing from 'components/Common/Spacing'
import { mediaQueryUp } from 'components/utils/breakpoint'
import eases from 'styles/tools/eases'
import config from 'constants/config'

export const Or = styled.div`
  display: flex;
  align-items: center;

  &::after,
  &::before {
    content: '';
    flex: 1;
    border-top: 1px solid ${({ theme }) => theme.palette.neutral.five};
    display: block;
  }
`

export const OrText = styled(BodyText)`
  margin: 0 ${rem(12)};
`

export const Form = styled.form`
  ${verticalChildSpacing[24]}

  & > label {
    display: block;

    & + label{
      margin-top: ${rem(16)};
    }
  }
`

export const TrustPilotLogo = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 98 33" width="98">
    <g clipPath="url(#a)">
      <path fill="#1A1918" d="M92.704 12.543h1.472V9.89h1.952v2.653h1.763V14h-1.763v4.726c0 .205.009.383.026.53a.914.914 0 0 0 .12.377c.062.103.156.18.282.231.126.052.297.078.514.078a9.7 9.7 0 0 0 .41-.009 2.06 2.06 0 0 0 .411-.06v1.507l-.633.068a5.737 5.737 0 0 1-.633.035c-.514 0-.928-.049-1.242-.146-.314-.097-.559-.24-.736-.428a1.48 1.48 0 0 1-.36-.71 5.224 5.224 0 0 1-.11-.977V14h-1.473v-1.456Zm-5.034 7.552c.433 0 .81-.091 1.13-.274.32-.183.582-.422.788-.72a3.13 3.13 0 0 0 .453-1.001 4.46 4.46 0 0 0 0-2.269 3.023 3.023 0 0 0-.453-1.002 2.426 2.426 0 0 0-.788-.71c-.32-.183-.697-.274-1.13-.274-.434 0-.81.091-1.13.274-.32.183-.583.42-.788.71a3.028 3.028 0 0 0-.454 1.002 4.512 4.512 0 0 0 0 2.269c.097.371.248.705.454 1.002.205.297.468.536.787.719.32.182.697.274 1.13.274Zm0 1.54c-.708 0-1.339-.116-1.892-.35a4.03 4.03 0 0 1-1.404-.968 4.13 4.13 0 0 1-.874-1.472c-.2-.57-.3-1.199-.3-1.884 0-.673.1-1.295.3-1.866.2-.57.49-1.062.874-1.473.382-.41.85-.733 1.404-.967.553-.234 1.184-.351 1.891-.351.709 0 1.34.117 1.893.35a4.039 4.039 0 0 1 1.404.968c.383.411.673.902.873 1.473.2.57.3 1.193.3 1.866 0 .685-.1 1.313-.3 1.884-.2.57-.49 1.061-.873 1.472a4.046 4.046 0 0 1-1.404.968c-.554.234-1.184.35-1.892.35ZM79.742 9.17h1.952v12.226h-1.952V9.17Zm-3.697 3.373h1.952v8.853h-1.952v-8.853Zm0-3.373h1.952v1.85h-1.952V9.17Zm-3.441 7.808c0-.4-.052-.787-.154-1.164a3.162 3.162 0 0 0-.463-1.002 2.39 2.39 0 0 0-.77-.702 2.095 2.095 0 0 0-1.062-.265c-.822 0-1.441.285-1.858.856-.417.571-.625 1.33-.625 2.277 0 .445.054.86.163 1.242.108.382.27.71.488.984.217.274.476.491.779.651.302.16.653.24 1.053.24.445 0 .822-.091 1.13-.274.308-.183.562-.42.762-.71.2-.292.343-.623.428-.994.086-.37.129-.75.129-1.139Zm-6.815-4.435h1.849v1.2h.034c.274-.514.657-.883 1.147-1.105a3.809 3.809 0 0 1 1.593-.334c.696 0 1.304.123 1.823.368a3.6 3.6 0 0 1 1.293 1.01c.343.428.6.928.77 1.498.172.571.258 1.182.258 1.833a6.48 6.48 0 0 1-.231 1.729 4.5 4.5 0 0 1-.703 1.481c-.314.428-.71.77-1.19 1.027-.48.257-1.044.386-1.695.386-.285 0-.57-.026-.856-.077a3.703 3.703 0 0 1-.822-.248 3.224 3.224 0 0 1-.728-.437 2.422 2.422 0 0 1-.556-.625h-.034v4.418h-1.952V12.543Zm-6.558 0h1.472V9.89h1.952v2.653h1.764V14h-1.764v4.726c0 .205.009.383.026.53a.912.912 0 0 0 .12.377.57.57 0 0 0 .282.231c.126.052.297.078.514.078.137 0 .274-.003.411-.009a2.08 2.08 0 0 0 .411-.06v1.507l-.634.068a5.744 5.744 0 0 1-.633.035c-.514 0-.928-.049-1.242-.146-.314-.097-.559-.24-.736-.428a1.475 1.475 0 0 1-.36-.71 5.31 5.31 0 0 1-.11-.977V14H59.23v-1.456Zm-6.439 6.01c.057.572.274.971.651 1.2.377.228.828.342 1.353.342.182 0 .39-.014.625-.043.234-.028.454-.083.66-.163a1.24 1.24 0 0 0 .504-.35c.131-.155.191-.357.18-.609a.864.864 0 0 0-.274-.616 1.906 1.906 0 0 0-.66-.385 6.417 6.417 0 0 0-.915-.249 40.247 40.247 0 0 1-1.045-.222 9.735 9.735 0 0 1-1.053-.291 3.384 3.384 0 0 1-.907-.463 2.134 2.134 0 0 1-.642-.745c-.16-.302-.24-.676-.24-1.121 0-.48.117-.882.35-1.207a2.69 2.69 0 0 1 .891-.788c.36-.2.76-.34 1.199-.42.44-.08.859-.12 1.258-.12.457 0 .893.05 1.31.146.417.098.794.255 1.13.471.337.217.617.5.84.848.222.348.362.768.419 1.258h-2.038c-.091-.468-.305-.781-.642-.941a2.666 2.666 0 0 0-1.156-.24c-.137 0-.3.011-.488.034a2.277 2.277 0 0 0-.53.129 1.117 1.117 0 0 0-.42.274.655.655 0 0 0-.171.47c0 .24.082.434.248.582.166.149.382.272.65.369.269.097.574.18.917.248.342.069.696.143 1.062.223.353.08.702.177 1.044.29.343.115.648.269.916.463s.485.44.65.736c.166.297.25.662.25 1.096 0 .525-.12.97-.36 1.336-.24.365-.551.662-.934.89a4.238 4.238 0 0 1-1.275.497 6.46 6.46 0 0 1-1.387.154c-.56 0-1.076-.063-1.55-.189a3.607 3.607 0 0 1-1.233-.573 2.765 2.765 0 0 1-.822-.959c-.2-.382-.305-.836-.317-1.361h1.952Zm-3.321 2.843h-1.918v-1.233h-.034a2.68 2.68 0 0 1-1.07 1.07 2.908 2.908 0 0 1-1.447.403c-1.165 0-2.007-.288-2.526-.865-.52-.576-.78-1.447-.78-2.611v-5.617h1.953v5.428c0 .777.148 1.325.445 1.644.297.32.713.48 1.25.48.411 0 .753-.063 1.027-.189a1.8 1.8 0 0 0 .668-.505c.172-.21.294-.465.368-.762a3.95 3.95 0 0 0 .112-.959v-5.136h1.952v8.852Zm-14.146-8.853h1.832v1.713h.034c.057-.24.168-.474.334-.702a3.213 3.213 0 0 1 1.379-1.079c.285-.114.576-.171.873-.171.228 0 .385.006.47.017l.266.034v1.884a9.431 9.431 0 0 0-.42-.06 3.525 3.525 0 0 0-.419-.026c-.331 0-.642.066-.933.197a2.145 2.145 0 0 0-.762.582 2.847 2.847 0 0 0-.514.95 4.106 4.106 0 0 0-.188 1.302v4.212h-1.952v-8.853ZM25.856 9.17h9.897v1.85h-3.887v10.376h-2.14V11.02h-3.87V9.17Z"/>
      <path fill="#3ABA72" d="m23.577 9.17-8.94-.001L11.873.667l-2.761 8.5H.173l7.232 5.256-2.762 8.503 7.233-5.254 7.23 5.254-2.762-8.5 7.233-5.256Z"/>
      <path fill="#1A4D26" d="m16.97 16.352-.626-1.927-4.469 3.247 5.095-1.32Z"/>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.172.667h97.72v32H.171z"/>
      </clipPath>
    </defs>
  </svg>
}

export const TrustPilotLogoSmall = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
    <path d="M21.4791 8.37669L13.2744 8.37526L10.7396 0.572601L8.20506 8.37439L0 8.37304L6.63826 13.1974L4.10319 21.0008L10.7405 16.1786L17.3759 21.0008L14.8415 13.1991L21.4791 8.37669Z" fill="#3ABA72"/>
    <path d="M15.4158 14.9678L14.8412 13.1991L10.7402 16.1786L15.4158 14.9678Z" fill="#1A4D26"/>
  </svg>
}

export const FacebookLogo = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.7397 10.2141C20.7397 4.69124 16.2626 0.214096 10.7397 0.214096C5.21689 0.214096 0.739746 4.69124 0.739746 10.2141C0.739746 15.2055 4.39653 19.3427 9.17725 20.0927V13.1048H6.63832V10.2141H9.17725V8.01088C9.17725 5.50481 10.6701 4.12052 12.9544 4.12052C14.0487 4.12052 15.193 4.31553 15.193 4.31553V6.7766H13.9319C12.6897 6.7766 12.3022 7.54731 12.3022 8.33838V10.2141H15.0758L14.6322 13.1048H12.3022V20.0927C17.083 19.3427 20.7397 15.2055 20.7397 10.2141Z" fill="#1877F2"/>
  </svg>
}

export const ColouredFacebookRoundIcon = styled(FacebookRoundIcon)`
  color: #1877F2;
`

const ItemTransition = keyframes`
  0% {
    transform: translateX(0);
  }

  42% {
    transform: translateX(0);
  }

  /* Transition to slide 2 */

  50% {
    transform: translateX(calc(-100% - ${rem(16)}));
  }

  92% {
    transform: translateX(calc(-100% - ${rem(16)}));
  }

  /* Transition to slide 1 */

  100% {
    transform: translateX(0);
  }
`

const USPs = styled.div`
  display: grid;
  gap: ${rem(16)};
  overflow: visible;
  animation: ${ItemTransition} 8s infinite ${eases.power2.inOut};
  grid-template-columns: repeat(2, 100%);
  width: 100%;

  ${mediaQueryUp.lg} {
    animation: none;
    grid-template-columns: unset;
    grid-auto-columns: none;
    grid-auto-flow: column;
  }
`

const USP = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  * + * {
    margin-left: ${rem(8)};
  }
`

const BubbleTransition = keyframes`
  0% {
      width: ${rem(16)};
  }

  42% {
      width: ${rem(16)};
  }

  50% {
      width: ${rem(8)};
  }

  92% {
      width: ${rem(8)};
  }

  100% {
      width: ${rem(16)};
  }
`

const BubbleProgressTransition = keyframes`
  0% {
    transform: translateX(-100%);
    opacity: 1;
  }

  /* Slide across the bubble */

  42% {
    transform: translateX(0%);
    opacity: 1;
  }

  /* Fade out as we change slides */

  50% {
    transform: translateX(0%);
    opacity: 0;
  }

  /* Wait for our turn again */

  92% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(-100%);
    opacity: 1;
  }
`

const CarouselBubbles = styled.div`
  display: flex;
  justify-content: center;
  gap: ${rem(4)};

  ${mediaQueryUp.lg} {
    display: none;
  }
`

const CarouselBubble = styled.div`
  position: relative;
  height: ${rem(8)};
  width: ${rem(8)};
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.theme.palette.neutral.eight};
  animation: ${BubbleTransition} 8s infinite;
  border: 1px solid ${props => props.theme.palette.neutral.one};
  overflow: hidden;
  transform: translateZ(0);


  &:nth-child(2) {
    animation-delay: 4s;

    &::after {
      animation-delay: 4s;
    }
  }

  &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);
    background-color: ${props => props.theme.palette.neutral.one};
    animation: ${BubbleProgressTransition} 8s infinite;
  }
`

const AnimationContainer = styled.div`
  overflow: hidden;
`

export const TrustIndicator = () => (
  <AnimationContainer>
    <USPs>
      <USP>
        <TrustPilotLogo />
        <Spacing ml={4}>
          <BodyText weight="bold" variant="large">4.8/5 · ‘Excellent’</BodyText>
        </Spacing>
      </USP>
      <USP>
        <ColouredFacebookRoundIcon/>
        <Spacing ml={4}>
          <BodyText weight="bold" variant="large" align="center">1,484,233 followers</BodyText>
        </Spacing>
      </USP>
    </USPs>
    <CarouselBubbles>
      <CarouselBubble />
      <CarouselBubble />
    </CarouselBubbles>
  </AnimationContainer>
)

export const getModalHeaderTitle = (mode: string | undefined) => {
  if (config.businessTraveller.currentAccountMode === 'business') {
    return ''
  }
  switch (mode) {
    case 'login':
      return 'Members save up to 70%'
    case 'loginPassword':
      return 'Welcome back'
    case 'join':
      return 'Welcome'
    case 'forgotPassword':
      return 'A reset link has been sent to your email'
    case 'resetPassword':
      return 'Update your password'
    case 'tripPlannerLogin':
      return 'Sign up to start saving offers and planning for your next escape.'
    default:
      return ''
  }
}
